import React, { useRef, useEffect, useMemo } from 'react';
import * as d3 from 'd3';
import { BaseType, Selection } from 'd3-selection';

export default function useD3 (
  renderChartFunction: (selection: Selection<SVGSVGElement, unknown, BaseType, unknown>) => unknown,
  dependencies: unknown[] | undefined = undefined,
) {
  const ref = useRef() as React.MutableRefObject<SVGSVGElement>;

  const memoizedChartFunction = useMemo(() => {
    if (dependencies && dependencies.some(dependency => dependency === undefined || dependency === null)) {
      return () => undefined;
    }
    return renderChartFunction;
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  dependencies ? dependencies : [renderChartFunction],
  );

  useEffect(() => {
    memoizedChartFunction(d3.select(ref.current));
  }, [memoizedChartFunction]);
  return ref;
}
